import { render } from "./ShopHistory.vue?vue&type=template&id=5c8eccde&scoped=true"
import script from "./ShopHistory.vue?vue&type=script&lang=js"
export * from "./ShopHistory.vue?vue&type=script&lang=js"

import "./ShopHistory.vue?vue&type=style&index=0&id=5c8eccde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8eccde"]])

export default __exports__